import { Avatar as AntAvatar, Flex } from 'antd'
import { User } from 'iconsax-react'
import { ReactNode } from 'react'

import { Text } from './Text'

import type { AvatarProps as AntAvatarProps, FlexProps } from 'antd'

export type AvatarProps = {
  avatarProps?: AntAvatarProps
  name?: string
  position?: string
  children?: ReactNode
} & Omit<FlexProps, 'children'>

export const Avatar = ({
  name,
  position,
  avatarProps,
  children,
  ...props
}: AvatarProps) => {
  return (
    <Flex gap={12} align="center" {...props}>
      <div>
        <AntAvatar size={32} icon={<User size={16} />} {...avatarProps}>
          {children}
        </AntAvatar>
      </div>

      <Flex hidden={!name && !position} vertical className="avatar-max-width">
        <Text weight={600} isEllipsis>
          {name}
        </Text>

        <Text size={12} type="secondary" isEllipsis>
          {position}
        </Text>
      </Flex>
    </Flex>
  )
}

Avatar.Group = AntAvatar.Group
